<template>
  <v-radio-group
  
    :disabled="$store.getters.isDisabled"
    :value="value"
    @change="$emit('input', $event)"
  >
    <v-radio
      v-for="item in options"
      :key="'option-' + item.slug"
      :label="item.title"
      :value="item.slug"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: [
        {
          slug: "tile_only_wet_walls",
          title: this.$t("Plaadi ainult märguvad seinad (mittemärguvad seinad on värvitud)"),
        },
        {
          slug: "tile_dry_walls",
          title: this.$t("Plaadi kõik seinad (hinnale lisandub 60 € plaaditava m² kohta)"),
        },
      ],
    };
  },
};
</script>
